<template>
	<el-container>
		<Header></Header>
		<el-main class="mainWrap">
			<el-carousel trigger="click" :interval="5000" height="960px">
				<el-carousel-item>
					<div class="carouselItem">
						<img class="bannerImg" :src="require('@/assets/index/banner.jpg')" />
					</div>
				</el-carousel-item>
			</el-carousel>
			<div class="module04">
				<div class="moduleBox">
					<CompanySlider></CompanySlider>
				</div>
			</div>
			<Footer></Footer>
		</el-main>
	</el-container>
</template>

<script>
	import CompanySlider from '@/components/companySlider.vue';
	export default {
		components:{
			CompanySlider,
		},
		data() {
			return {
				selectShow01:false,
				selectShow02:false,
				selectShow03:false,
				selectShow04:false,
				current:'0',
				kfShow:false,
				
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods: {
			kefuShow(){
				this.$refs.kefu.setShow();
			},
			link(link){
				if(link == 'kefu'){
					this.kefuShow();
				}else{
					this.$router.push({path:link})
				}
				
			},
			switchSlde(type){
				if(type == 'prev'){
					this.$refs.carouselSlide.prev()
				}else{
					this.$refs.carouselSlide.next()
				}
			},
			slideChange(name){
				this.current = name;
			},
			currentClick(index){
				this.current = index;
				this.$refs.carouselSlide.setActiveItem(index)
			}
		}
	}
</script>
<style lang="scss" scoped>
	.mainWrap{
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		padding: 0;
		z-index: 1;
		.carouselItem{
			position: relative;
			width: 100%;
			height: 960px;
			cursor: pointer;
			.bannerImg {
			  position: absolute;
			  left: 50%;
			  top: 0;
			  margin-left: -960px;
			  z-index: 2;
			  width: 1920px;
			}
			.bannerBox{
				width: 1200px;
				padding-top: 207px;
				margin: 0 auto;
				position: relative;
				z-index: 3;
				.bannerTitle{
					width: 100%;
					font-size: 38px;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 45px;
					text-shadow: 0px 2px 1px rgba(0,0,0,0.5);
				}
				.bannerDesc{
					width: 100%;
					font-size: 28px;
					color: rgba(255,255,255,0.8);
					line-height: 33px;
					margin-top: 24px;
				}
				.bannerLink{
					display: block;
					width: 180px;
					height: 54px;
					background: #0948AD;
					margin-top: 60px;
					font-size: 14px;
					color: #FFFFFF;
					line-height: 54px;
					text-align: center;
				}
				.tips{
					margin-top: 86px;
					z-index: 3;
					.line{
						width: 52px;
						height: 1px;
						background: #FFFFFF;
					}
					.tipsTxt{
						font-size: 14px;
						color: #FFFFFF;
						line-height: 17px;
						margin-top: 19px;
					}
				}
			}
			
		}
		
		.module04{
			width: 100%;
			background: #FFFFFF;
			padding-top: 50px;
			padding-bottom: 51px;
			
		}
		.module05{
			width: 100%;
			background: #FFFFFF;
			
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/views/index.vue